import Vue from 'vue';
import Router, { Route } from 'vue-router';

import { store, bus } from './index';
import { Forbidden } from '@servicestack/vue';
import Home from '../components/Home/index.vue';
import About from '../components/About.vue';
import SignIn from '../components/SignIn.vue';
import SignUp from '../components/SignUp.vue';
import Resend from '../components/Resend.vue';
import Profile from '../components/Profile.vue';
import Admin from '../components/Admin/index.vue';
import Study from '../components/Study/index.vue';
import Data from '../components/Data/index.vue';
import Verify from '../components/Verify/Verify.vue';
import ForgotPassword from '../components/ForgotPassword.vue';
import Reset from '../components/Reset.vue';
import Access from '../components/Access.vue';
import Submission from '../components/Submission.vue';

export enum Routes {
    Home = '/',
    About = '/about',
    SignIn = '/signin',
    ForgotPassword = '/forgot',
    Reset = '/reset/:id',
    SignUp = '/signup',
    Resend = '/resend',
    Profile = '/profile',
    Admin = '/admin',
    Study = '/study',
    Data = '/data',
    Verify = '/verify/:id',
    Access = '/access/:id',
    Forbidden = '/forbidden',
    Submission = '/submission',
}

Vue.use(Router);

function requiresAuth(to: Route, from: Route, next: (to?: string) => void) {
    if (!store.userSession) {
        next(`${Routes.SignIn}?redirect=${encodeURIComponent(to.path)}`);
        return;
    }
    next();
}

function requiresRole(role: string) {
    return (to: Route, from: Route, next: (to?: string) => void) => {
        if (!store.userSession) {
            next(`${Routes.SignIn}?redirect=${encodeURIComponent(to.path)}`);
        } else if (
            !store.userSession.roles ||
            store.userSession.roles.indexOf(role) < 0
        ) {
            next(`${Routes.Forbidden}?role=${encodeURIComponent(role)}`);
        } else {
            next();
        }
    };
}

const routes = [
    { path: Routes.Home, component: Home, props: { name: 'Vue' } },
    { path: Routes.About, component: About, props: { message: 'About page' } },
    { path: Routes.SignIn, component: SignIn },
    { path: Routes.ForgotPassword, component: ForgotPassword },
    { path: Routes.Reset, component: Reset },
    { path: Routes.SignUp, component: SignUp },
    { path: Routes.Resend, component: Resend },
    { path: Routes.Profile, component: Profile, beforeEnter: requiresAuth },
    { path: Routes.Admin, component: Admin, beforeEnter: requiresRole('Admin') },
    { path: Routes.Study, component: Study, beforeEnter: requiresAuth },
    { path: Routes.Data, component: Data, beforeEnter: requiresAuth },
    { path: Routes.Submission, component: Submission, beforeEnter: requiresAuth },
    { path: Routes.Verify, component: Verify },
    { path: Routes.Access, component: Access },
    { path: Routes.Forbidden, component: Forbidden },
    { path: '*', redirect: '/' },
];

export const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    // base: process.env.BASE_URL,
    routes,
});

export const redirect = (path: string) => {
    const externalUrl = path.indexOf('://') >= 0;
    if (!externalUrl) {
        router.push({ path });
    } else {
        location.href = path;
    }
};

bus.$on('signout', async () => {
    // reload current page after and run route guards after signing out.
    const to = router.currentRoute;
    router.replace('/');
    // router.replace(to);
});
